var _rect, _path, _circle, _text, _rect2, _text2, _text3, _circle2, _text4, _rect3, _text5, _text6, _circle3, _text7, _rect4, _text8, _text9, _circle4, _text0, _rect5, _text1, _text10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreDailyCheckInCheckOutShiftTimelineMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 360,
    height: 710,
    viewBox: "0 0 360 710",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore mobile shift evidence timeline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 710,
    rx: 28,
    fill: "#FFFFFF",
    stroke: "#D2E1F2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 92V617",
    stroke: "#D2E1F2",
    strokeWidth: 3,
    strokeDasharray: "4 8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 92,
    r: 18,
    fill: "#087CFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 98,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "01")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 54,
    width: 238,
    height: 92,
    rx: 18,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 88,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "CHECK IN")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 119,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Driver + asset linked")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 262,
    r: 18,
    fill: "#FF2775"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 268,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "02")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 224,
    width: 238,
    height: 92,
    rx: 18,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 258,
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "CAPTURE")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 289,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Walk-around + odometer")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 432,
    r: 18,
    fill: "#087CFF"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 438,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "03")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 394,
    width: 238,
    height: 92,
    rx: 18,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 428,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "OPERATE")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 459,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Shift activity recorded")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 602,
    r: 18,
    fill: "#FF2775"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 608,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "04")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 564,
    width: 238,
    height: 92,
    rx: 18,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 598,
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "CHECK OUT")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 629,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "New evidence compared")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreDailyCheckInCheckOutShiftTimelineMobile);
export default __webpack_public_path__ + "static/media/fleetcore-daily-check-in-check-out-shift-timeline-mobile.391a7f9c245a9117c719e8243dc393c4.svg";
export { ForwardRef as ReactComponent };